var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"appear":"","name":"slide-page","mode":"out-in"}},[_c('router-view',{key:_vm.$route.params.productId})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }